import { createTheme } from '@mui/material/styles';

let theme = createTheme({
  palette: {
    primary: { main: '#00E5FF',seeThrough:'#00e5ff7e'},     // arcade-blue
    secondary: { main: '#FF2D95' },   // arcade-pink
    background: { default: '#0A0F0D', paper: '#0A0F0D' },
    divider: '#39FF14',               // arcade-green
    green: { main: '#39FF14' },
    orange: { main: '#FF5F1F' },
    text: { primary: '#FFFFFF', secondary: '#39FF14',pink:'#FF2D95' },

  },

  // --- Typography: fixed, consistent sizes everywhere ---
  typography: {
    htmlFontSize: 16,          // ensures 1rem = 16px everywhere
    fontSize: 16,              // default body size base
    fontFamily: "'Press Start 2P', monospace",
    allVariants: { color: '#00E5FF' },

    // Headings
    h1: { fontSize: '5rem', fontWeight: 400, lineHeight: 1.2, letterSpacing: 0 },
    h2: { fontSize: '2rem',   fontWeight: 400, lineHeight: 1.25, letterSpacing: 0 },
    h3: { fontSize: '1.75rem',fontWeight: 400, lineHeight: 1.3, letterSpacing: 0 },
    h4: { fontSize: '1.5rem', fontWeight: 400, lineHeight: 1.35, letterSpacing: 0 },
    h5: { fontSize: '1.25rem',fontWeight: 400, lineHeight: 1.4, letterSpacing: 0 },
    h6: { fontSize: '1.125rem',fontWeight: 400, lineHeight: 1.45, letterSpacing: 0 },

    // Subtitles
    subtitle1: { fontSize: '1rem',   fontWeight: 400, lineHeight: 1.5 },
    subtitle2: { fontSize: '0.9rem', fontWeight: 400, lineHeight: 1.5 },

    // Body text
    body1: { fontSize: '0.95rem', lineHeight: 1.6 },
    body2: { fontSize: '0.85rem', lineHeight: 1.6 },

    // UI elements
    button:  { fontSize: '0.875rem', fontWeight: 400, lineHeight: 1.75, textTransform: 'none' },
    caption: { fontSize: '0.75rem',  lineHeight: 1.4 },
    overline:{ fontSize: '0.7rem',   lineHeight: 1.4, textTransform: 'uppercase' },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ':root': {
          '--arcade-bg': '#0A0F0D',
          '--arcade-blue': '#00E5FF',
          '--arcade-pink': '#FF2D95',
          '--arcade-green': '#39FF14',
          '--arcade-white': '#FFFFFF',
        },
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          width: '100%',
        },
        '#root': {
          width: '100%',
          minHeight: '100vh',
          minWidth: 0,
        },
        body: {
          margin: 0,
          paddingBottom: '130px',
          paddingLeft:'5px',
          paddingRight:'5px',// Extra space for bottom nav
          background: 'linear-gradient(135deg, #0A0F0D, #1A1F1D)',
          color: '#00E5FF',
          fontFamily: "'Press Start 2P', monospace",
          fontWeight: 400,
          fontSize: '10px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          minHeight: '100vh',
          overflowX: 'hidden',
        },
        '.container': {
          backgroundColor: '#FFFFFF',
          color: '#FF2D95',
          textShadow: '#FF2D95 0px 0px 10px',
          fontFamily: 'inherit',
          padding: '2rem',
          maxWidth: '600px',
          margin: '2rem auto',
          borderRadius: '8px',
        },
        option: {
          fontFamily: 'inherit',
          backgroundColor: '#FF2D95',
          color: '#FFFFFF',
          border: 'none',
          padding: '0.5rem 1rem',
          margin: '0.5rem 0.1rem',
          fontSize: '1rem',
          cursor: 'pointer',
          borderRadius: '4px',
          transition: 'background-color 0.3s ease',
        },
        select: {
          fontFamily: 'inherit',
          backgroundColor: '#FF2D95',
          color: '#FFFFFF',
          border: 'none',
          padding: '0.5rem 1rem',
          margin: '0.5rem 0.1rem',
          fontSize: '1rem',
          cursor: 'pointer',
          borderRadius: '4px',
          transition: 'background-color 0.3s ease',
        },
        button: {
          fontFamily: 'inherit',
          backgroundColor: '#FF2D95',
          color: '#FFFFFF',
          border: 'none',
          padding: '0.5rem 1rem',
          margin: '0.5rem 0.1rem',
          fontSize: '1rem',
          cursor: 'pointer',
          borderRadius: '4px',
          transition: 'background-color 0.3s ease',
          '&:hover': {
            backgroundColor: '#00E5FF',
            boxShadow: '0 0 12px #00E5FF',
            color: '#FFFFFF',
          },
        },
        h1: {
          fontSize: '1.8rem',
          marginBottom: '1.5rem',
          textAlign: 'center',
        },
        h2: {
          fontSize: '1.5rem',
          marginBottom: '1rem',
          textAlign: 'center',
          color: '#39FF14',
        },
        p: {
          fontSize: '1rem',
          marginBottom: '1rem',
          lineHeight: 1.5,
          textAlign: 'center',
          color: '#FFFFFF',
        },
        '.form-group': {
          marginBottom: '1rem',
        },
        label: {
          display: 'block',
          fontWeight: 'bold',
          marginBottom: '0.5rem',
        },
        input: {
          backgroundColor: '#0A0F0D',
          color: '#FF2D95',
          border: '2px solid #00E5FF',
          padding: '0.5rem',
          fontSize: '1rem',
          width: '100%',
          boxSizing: 'border-box',
          borderRadius: '4px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          border: '4px solid #39FF14',
          borderRadius: 20,
          color: 'primary.main',
          p:2
          // (Optional) set a default bg only for contained
          // '&.MuiButton-contained': { backgroundColor: '#0A0F0D' },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: '#00E5FF',
          backgroundColor: '#0A0F0D',
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#00E5FF' },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#FF2D95' },
        },
        input: { color: '#00E5FF' },
      },
    },
    MuiInputLabel: { styleOverrides: { root: { color: '#00E5FF' } } },
    MuiSelect:     { styleOverrides: { icon: { color: '#00E5FF' } } },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        switchViewButton: {
          color: '#00E5FF',
          '&:hover': {
            backgroundColor: '#00e5ff1f',
          },
        },
        switchViewIcon: {
          color: '#00E5FF',
        },
      },
    },
    MuiPickersArrowSwitcher: {
      styleOverrides: {
        button: {
          color: '#00E5FF',
          '&:hover': {
            backgroundColor: '#00e5ff1f',
          },
          '&.Mui-disabled': {
            color: '#00e5ff7e',
          },
        },
        leftArrowIcon: {
          color: 'inherit',
        },
        rightArrowIcon: {
          color: 'inherit',
        },
      },
    },
    MuiMenu:       { styleOverrides: { paper: { backgroundColor: '#0A0F0D', color: '#00E5FF' } } },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "'Press Start 2P', monospace",
          color: '#00E5FF',
          '&.Mui-selected': { backgroundColor: '#FF2D95', color: '#0A0F0D' },
          '&.Mui-selected:hover': { backgroundColor: '#39FF14', color: '#0A0F0D' },
          '&:hover': { backgroundColor: '#1A1F1D' },
        },
      },
    },
  },
});
theme = createTheme(theme, {
  typography: {
    h1: { [theme.breakpoints.down('sm')]: { fontSize: '2rem' } },
    h2: { [theme.breakpoints.down('sm')]: { fontSize: '1.75rem' } },
    h3: { [theme.breakpoints.down('sm')]: { fontSize: '1.5rem' } },
    h4: { [theme.breakpoints.down('sm')]: { fontSize: '1.375rem' } },
    h5: { [theme.breakpoints.down('sm')]: { fontSize: '1.125rem' } },
    h6: { [theme.breakpoints.down('sm')]: { fontSize: '1rem' } },

    subtitle1: { [theme.breakpoints.down('sm')]: { fontSize: '0.95rem' } },
    subtitle2: { [theme.breakpoints.down('sm')]: { fontSize: '0.85rem' } },

    body1: { [theme.breakpoints.down('sm')]: { fontSize: '0.9rem' } },
    body2: { [theme.breakpoints.down('sm')]: { fontSize: '0.5rem' } },

    button:  { [theme.breakpoints.down('sm')]: { fontSize: '0.8125rem' } }, // 13px
    caption: { [theme.breakpoints.down('sm')]: { fontSize: '0.7rem' } },
    overline:{ [theme.breakpoints.down('sm')]: { fontSize: '0.65rem' } },
  },
});
export default theme;
